import React from 'react';

import {PlaceholderWrapperComponent} from "../../../placeholder/placeholder-wrapper";

export const PredictionPlaceholderInsight = (props) => {
  return (
    <PlaceholderWrapperComponent className={'prediction-placeholder-insight-container'}>
      <div className={'prediction-placeholder-insight-content'}>
        <div className={'prediction-placeholder-insight-text'}/>
        <div className={'prediction-placeholder-statistical-analysis'}/>
      </div>
    </PlaceholderWrapperComponent>
  )
}
